import Cookies from 'js-cookie'

const state = {
    sidebar: {
        opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : false,
        withoutAnimation: false
    },
    device: 'mobile',
    size: Cookies.get('size') || 'medium',
    isShowLoading: 0, // 1 显示 0 不显示
    LoadingNum: 0,
    showMenuPop: true
}

const mutations = {
    TOGGLE_SIDEBAR: state => {
        state.sidebar.opened = !state.sidebar.opened
        state.sidebar.withoutAnimation = false
        if (state.sidebar.opened) {
            Cookies.set('sidebarStatus', 1)
        } else {
            Cookies.set('sidebarStatus', 0)
        }
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
        Cookies.set('sidebarStatus', 0)
        state.sidebar.opened = false
        state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
        state.device = device
    },
    SET_SIZE: (state, size) => {
        state.size = size
        Cookies.set('size', size)
    },
    SET_ISSHOWLOADING: (state, show) => {
        state.isShowLoading = show
    },
    SET_LOADINGNUM: (state, num) => {
        state.LoadingNum = num
    },
    SET_MENU_POP(state, value) {
        state.showMenuPop = value
    }
}

const actions = {
    toggleSideBar({ commit }) {
        commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
        commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
        commit('TOGGLE_DEVICE', device)
    },
    setSize({ commit }, size) {
        commit('SET_SIZE', size)
    },
    setIsShowLoading({ commit }, show) {
        commit('SET_ISSHOWLOADING', show)
    },
    setLoadingNum({ commit }, num) {
        commit('SET_LOADINGNUM', num)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
